import { all, takeEvery, call, put } from "redux-saga/effects";
import { list, create, detail, update, remove, changeIndexes } from "services/apis/widgetChannel";
import actions from "./actions";
import * as _ from "lodash";
import { toastr } from "services/toastr";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* LIST({ payload }) {
  yield loading(true);

  const response = yield call(list, payload);
  if (response) {
    const meta = _.omit(response, "items");
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        list: response.items,
        meta,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* CREATE({ payload }) {
  const { body, listType, filter } = payload;
  yield loading(true);

  const response = yield call(create, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    if (listType === "custom") {
      yield put({
        type: actions.LIST,
        payload: {
          page: filter.page,
          pageSize: filter.pageSize,
          includes: filter.includes,
          filters: JSON.stringify([["widgetId", "=", body.widgetId]]),
        },
      });
    } else {
      // yield put({
      //   type: actions.LIST,
      //   payload: { page: filter.page, pageSize: filter.pageSize, includes: filter.includes },
      // });
      yield put({
        type: "widget/LIST",
        payload: {
          page: 1,
          pageSize: 100,
          filters: filter.filters,
          includes:
            "widgetChannels.channel.connection,widgetChannels.channel.tagGroup,widgetChannels.channel.alertTag,widgetChannels.channel.alertTag.alertType,widgetChannels.channel.alertTag.alertType.alertTypeStates",
        },
      });
    }
    toastr.success("create succeeded", "assigned channel to widget!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* DETAIL({ payload }) {
  const { id } = payload;
  yield loading(true);

  const response = yield call(detail, id);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* UPDATE({ payload }) {
  const { id, body, filter } = payload;
  // eslint-disable-next-line no-unused-vars
  const { page, pageSize, includes, filters } = filter;
  yield loading(true);

  const response = yield call(update, id, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    // yield put({ type: actions.LIST, payload: { page, pageSize, includes } });
    yield put({
      type: "widget/LIST",
      payload: {
        page: 1,
        pageSize: 100,
        filters,
        includes:
          "widgetChannels.channel.connection,widgetChannels.channel.tagGroup,widgetChannels.channel.alertTag,widgetChannels.channel.alertTag.alertType,widgetChannels.channel.alertTag.alertType.alertTypeStates",
      },
    });
    toastr.success("update succeeded", "widget channel updated!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* DELETE({ payload }) {
  const { id, widgetId, filter } = payload;
  const { page, pageSize, includes, filters } = filter;
  // let newPage = page;

  // if (totalItems % pageSize <= 1 && page !== 1) {
  //   newPage -= 1;
  // }

  yield loading(true);

  const response = yield call(remove, id);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    if (widgetId) {
      yield put({
        type: actions.LIST,
        payload: {
          page,
          pageSize,
          includes,
          filters: JSON.stringify([["widgetId", "=", widgetId]]),
        },
      });
    } else {
      // yield put({ type: actions.LIST, payload: { page, pageSize, includes } });
      yield put({
        type: "widget/LIST",
        payload: {
          page: 1,
          pageSize: 100,
          filters,
          includes:
            "widgetChannels.channel.connection,widgetChannels.channel.tagGroup,widgetChannels.channel.alertTag,widgetChannels.channel.alertTag.alertType,widgetChannels.channel.alertTag.alertType.alertTypeStates",
        },
      });
    }
    toastr.success("delete succeeded", "successfully deleted widget channel!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* CHANGE_INDEXES({ payload }) {
  // eslint-disable-next-line no-unused-vars
  const { body, filter } = payload;
  yield loading(true);

  const response = yield call(changeIndexes, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    toastr.success("update succeeded", "indexes updated!");

    // yield put({ type: "widget/LIST", payload: filter });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LIST, LIST),
    takeEvery(actions.CREATE, CREATE),
    takeEvery(actions.DETAIL, DETAIL),
    takeEvery(actions.UPDATE, UPDATE),
    takeEvery(actions.DELETE, DELETE),
    takeEvery(actions.CHANGE_INDEXES, CHANGE_INDEXES),
  ]);
}
